class FetchingStatusStore {
  private _requestsInProgress = new Set<string>();
  private readonly _listeners = new Set<() => void>();

  public subscribe = (listener: () => void) => {
    this._listeners.add(listener);

    return () => {
      this._listeners.delete(listener);
    };
  };

  public getSnapshot = () => Boolean(this._requestsInProgress.size);

  private _emitChange = () => {
    for (const listener of this._listeners) {
      listener();
    }
  };

  public addRequest = (requestId: string) => {
    this._requestsInProgress.add(requestId);
    this._emitChange();
  };

  public removeRequest = (requestId: string) => {
    this._requestsInProgress.delete(requestId);
    this._emitChange();
  };
}

export const FetchingStatusStoreInstance = new FetchingStatusStore();
